class RequestCreditStatusData {
    static data() {
        return {
            in_work: {slug: "in_work", "label": "В работе", class: "in_work"},
            consultation: {slug: "consultation", "label": "Консультация", class: "consultation"},
            consideration: {slug: "consideration", "label": "Рассматривается", class: "consideration"},
            limit: {slug: "limit", "label": "Лимит", class: "limit"},
            approved: {slug: "approved", "label": "Одобрен", class: "approved"},
            soglasovanie_ts: {slug: "soglasovanie_ts", "label": "Согласование ТС", class: "soglasovanie_ts"},
            ozidanie: {slug: "ozidanie", "label": "Ожидание", class: "ozidanie"},
            dokumenty_gotovy: {slug: "dokumenty_gotovy", "label": "Документы готовы", class: "dokumenty_gotovy"},
            jumped: {slug: "jumped", "label": "Соскок", class: "jumped"},
            rejection: {slug: "rejection", "label": "Отказ", class: "rejection"},
            issued: {slug: "issued", "label": "Оформлен", class: "issued"},
        };
    }
    static dataAsArray() {
        let arr = [];
        let data = this.data();
        for (status in data) {
            arr.push(data[status])
        }
        return arr;
    }
    static forSelect() {
        return this.dataAsArray().map(function (item) {
            return {id: item.slug, text: item.label};
        })
    }
}

export default RequestCreditStatusData;
